import { Component, OnInit } from '@angular/core';
import { Observable, Subject, timer } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AuthService } from 'src/app/services/auth.service';
import { Tabel } from 'src/app/interfaces/auth.interface';

@Component({
  selector: 'app-check-mail',
  templateUrl: './check-mail.component.html',
  styleUrls: ['./check-mail.component.scss']
})
export class CheckMailComponent implements OnInit {

  timer: number;

  destroy = new Subject();

  rxjsTimer = timer(1000, 1000);

  showDialog = false
  
  showNotice = false;

  userPassedData: Tabel[] = []


  constructor(private as:AuthService) { }

  ngOnInit() {
    
    this.as.getUserDataId().subscribe(data => { 
      this.userPassedData = data.map(element => {
        return {
          id:element.payload.doc.id,
          ...element.payload.doc.data() as {},
        }  
      })
      console.log("SESSION PASSED = ", data.length)
    })
    
    this.rxjsTimer.pipe(takeUntil(this.destroy)).subscribe(val => {
      this.timer = val;

      if (this.timer === 60) {
        this.showDialog = true;
      }

      if (this.timer >= 120) {
        this.as.openSesstion = false
        this.as.deletUserDataPass(this.userPassedData[0].id)
        .then(()=>{
          console.log('DELETED FOWRWORD USER DATA, SESSION DONE')
        })
        .catch(error=>console.log(error))
        this.destroy.next();
        this.destroy.complete();
        this.showDialog = false;
        this.showNotice = true;
      }
    })
  }

}
